import {
  getAllPlans,
} from '@/api/plan.api'

import {
  getCourse,
} from '@/api/course.api'

const state = {
  plan: {},
  plans: [],
  course: {},
}

const mutations = {
  setPlan (state, plan) {
    state.plan = plan
  },

  setPlans (state, plans) {
    state.plans = plans
  },

  setCourse (state, course) {
    state.course = course
  }
}

const getters = {
  plan ({ plan }) {
    return plan
  },

  plans ({ plans }) {
    return plans
  },

  course ({ course }) {
    return course
  }
}

const actions = {
  async getPlans ({ commit }) {
    const plans = await getAllPlans()

    commit('setPlans', plans)
  },

  async getCourse ({ commit }, id) {
    commit('setCourse', await getCourse(id))
  }
}



export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
